import type { CloudflareImage, Organization, OrganizationMemberPage } from "../types";
import { OrganizationScope } from "../types";

const createdAt = "2024-01-01T10:00:00Z";

const createImage = (id: string, variant: string): CloudflareImage => ({
	id,
	variant,
});

const emptyMembersPage: OrganizationMemberPage = {
	nodes: [],
	totalCount: 0,
	totalPages: 0,
};

const createOrganization = ({
	id,
	name,
	slug,
	logo,
	scopes,
}: {
	id: string;
	name: string;
	slug: string;
	logo: CloudflareImage;
	scopes: OrganizationScope[];
}): Organization => ({
	id,
	name,
	slug,
	logo,
	createdAt,
	address: "123 Main St, Berlin, Germany",
	email: `contact@${slug}.com`,
	phone: "+49 30 12345678",
	hubs: [],
	members: emptyMembersPage,
	pharmacyHubs: {
		nodes: [],
		totalCount: 0,
		totalPages: 0,
	},
	warehouses: {
		nodes: [],
		totalCount: 0,
		totalPages: 0,
	},
	scopes,
	supportEmail: `support@${slug}.com`,
});

const DM = createOrganization({
	id: "DM",
	name: "Drogeriemarkt",
	slug: "dm",
	logo: createImage("org-logo-dm", "/storybook/dm.webp"),
	scopes: [OrganizationScope.Vending],
});

const Rossmann = createOrganization({
	id: "ROSSMANN",
	name: "Rossmann",
	slug: "rossmann",
	logo: createImage("org-logo-rossmann", "/storybook/rossmann.svg"),
	scopes: [OrganizationScope.Vending],
});

const Bace = createOrganization({
	id: "BACE",
	name: "Bace",
	slug: "bace",
	logo: createImage("org-logo-bace", "/storybook/bacehub_logo.jpeg"),
	scopes: [OrganizationScope.Vending, OrganizationScope.ClickNCollect, OrganizationScope.T1],
});

export const organizations = {
	DM,
	Rossmann,
	Bace,
};
